var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8L2.75 6.5M2.75 6.5L8 1.25L13.25 6.5M2.75 6.5V14C2.75 14.4142 3.08579 14.75 3.5 14.75H5.75M13.25 6.5L14.75 8M13.25 6.5V14C13.25 14.4142 12.9142 14.75 12.5 14.75H10.25M5.75 14.75C6.16421 14.75 6.5 14.4142 6.5 14V11C6.5 10.5858 6.83579 10.25 7.25 10.25H8.75C9.16421 10.25 9.5 10.5858 9.5 11V14C9.5 14.4142 9.83579 14.75 10.25 14.75M5.75 14.75H10.25",
    stroke: "#EAA827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon2);
export default __webpack_public_path__ + "static/media/info-icon-2.5a79206168f9ce617dddd69dd46b042b.svg";
export { ForwardRef as ReactComponent };